<div class="stc__container--labels">
    <p class="stc__text--label" [style.width]="label.width" *ngFor="let label of statisticsLabels">{{label.text.key | translate}}</p>
</div>
<div class="stc__container--content" #scrollContainer>
    <ng-content></ng-content>
</div>
